import { render, staticRenderFns } from "./analytics.vue?vue&type=template&id=f5565f8c&scoped=true&"
import script from "./analytics.vue?vue&type=script&lang=js&"
export * from "./analytics.vue?vue&type=script&lang=js&"
import style0 from "./analytics.vue?vue&type=style&index=0&id=f5565f8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5565f8c",
  null
  
)

export default component.exports